import { reduce, transform, map } from 'lodash';
import core, { App } from '@gin-betting/core';
import { TopTournamentZone } from '@gin-betting/constants';
import { BannerTypes } from '@gin-betting/banners';

import { ParentPath } from 'types';
import type { MatchIdsBySport, WidgetType, MobileWidgetType } from './types';
import { ExtendedRouts } from 'app-constants';
import {
    ALL,
    ZONE_LOCATIONS,
    MARKETS_ACTIVE_STATUSES,
    MARKET_LIMIT,
} from './constants';
import { getMissingMatches } from './actions';

const {
    constants: { SportType },
} = core;

const zoneIdsMap = {
    [SportType.Classic]: TopTournamentZone.ClassicLeft,
    [SportType.Esport]: TopTournamentZone.EsportLeft,
    [SportType.Mix]: TopTournamentZone.MixLeft,
};

export const getTopTournamentsVars = (sportType: App.SportType) => ({
    zoneId: zoneIdsMap[sportType],
    count: 20,
});

export function getLinkToTopTournamentBySlug(
    slug: string,
    route: ParentPath
): string {
    return `${route}${ExtendedRouts.TOURNAMENT}${slug}`;
}

export function groupBannerItemsBySport(
    bannerItems: BannerTypes.BannerSportEvent[],
    defaultAcc?: MatchIdsBySport
): MatchIdsBySport {
    return reduce(
        bannerItems,
        (acc, { group, id }) => {
            const sportId = group?.groupBy ?? ALL;

            acc[sportId] = (acc[sportId] || new Set<string>()).add(id);

            return acc;
        },
        defaultAcc ?? {}
    );
}

type GetAttributesByPeriodArgs =
    | { [key in WidgetType]: number }
    | { [key in MobileWidgetType]: number };

export const getAttributesByPeriod = (
    topMatchListIndexConfig: GetAttributesByPeriodArgs
): { [key: string]: BannerTypes.BannerZoneAttributes[] } => {
    return transform(topMatchListIndexConfig, (acc, index, type) => {
        acc[type] = map(ZONE_LOCATIONS, pageLocation => ({
            index,
            pageLocation,
        }));
    });
};

export const makeGetMissingMatches = (sportEventsIds: string[]) =>
    getMissingMatches({
        sportEventsIds,
        isTopMarkets: true,
        marketLimit: MARKET_LIMIT,
        withMarketsCount: true,
        marketStatuses: MARKETS_ACTIVE_STATUSES,
    });
